import {Injectable} from "@angular/core";
import {ApiConfigService} from "./api-config.service";
import {tap} from "rxjs/operators";
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class GlobalDataService {
    constructor(private apiConfig: ApiConfigService, private translateService: TranslateService) {
    }

    public languages = [{langIcon: 'GR', label: 'Greece', value: 'el'}, {
        langIcon: 'GB',
        label: 'United Kingdom',
        value: 'en'
    }];
    public currentUser = {};
    public globalData;
    public domain;
    public currentMobileLang = 'el';

    getLanguages() {
        return this.apiConfig.get("api/languages/all");
    }


    getApplicationData() {
        return this.apiConfig.get("api/global-data")
            .pipe(
                tap((values) => {
                    this.globalData = values;
                })
            );
    }

    getObjectTranslation(array, key, lang?): string {
        lang = lang ? lang : this.translateService.currentLang;
        return array.filter((x) => {
            return x['language']['languageIso'] === lang
        })[0][key];
    }

    getCountryJson():Observable<any>{
        return this.apiConfig.get("assets/i18n/countries_"+this.translateService.currentLang+".json");
    }

    getCurrentLang(){
        return this.translateService.currentLang;
    }

    getRemoteContext(){
        return this.domain ==='culturevr'? '' : '/remote';
    }
}